// FareHarbor booking URL helper.
// Item IDs + flow are configured by Hacienda Carey.
const BASE = "https://fareharbor.com/embeds/book/haciendacarey/";
const FLOW = "1412085";

const ITEM_IDS = {
  "horseback-beginner": "639211",
  "horseback-sunset": "639214",
  "horseback-family": "755971",
  "snorkel-black-eagle": "640481",
  "kids-farm": "731589",
  scuba: null, // not launched yet
};

// Per-item flow overrides (defaults to FLOW when not listed).
const ITEM_FLOWS = {
  "horseback-family": "1431698",
};

export function fareharborUrl(activityId, opts = {}) {
  const id = ITEM_IDS[activityId];
  const path = id ? `items/${id}/` : "";
  const url = new URL(BASE + path);

  url.searchParams.set("full-items", "yes");
  url.searchParams.set("flow", ITEM_FLOWS[activityId] || FLOW);

  // UTM tracking
  url.searchParams.set("utm_source", opts.utm_source || "website");
  url.searchParams.set("utm_medium", opts.utm_medium || "book-cta");
  url.searchParams.set(
    "utm_campaign",
    opts.utm_campaign || activityId || "general",
  );
  if (opts.utm_content) url.searchParams.set("utm_content", opts.utm_content);

  return url.toString();
}

export function hasItemId(activityId) {
  return Boolean(ITEM_IDS[activityId]);
}

// All FareHarbor URLs auto-open as Lightframe via the
// /api/v1/?autolightframe=yes script in <head>.
// Keep target/rel as a graceful fallback.
export const FAREHARBOR_LINK_PROPS = {
  target: "_blank",
  rel: "noopener noreferrer",
};
